import type { TUser } from '@shared/types/user';
import type { TProgram } from '@shared/types/program';
import type { TSection } from '@shared/types/section';
import type { ValueOf } from '@shared/types/utilities';
import type { TMedia } from '@shared/types/media';

export const FIELD_ATTACHMENT_TYPES = {
  image: 'IMAGE',
  video: 'VIDEO',
  pdfDoc: 'PDF_DOC',
} as const;

export const FIELD_TYPES = {
  shortAnswer: 'SHORT_ANSWER',
  paragraph: 'PARAGRAPH',
  checklist: 'CHECKLIST',
  dropdown: 'DROPDOWN',
  email: 'EMAIL',
  date: 'DATE',
  dateTime: 'DATETIME',
  phoneNumber: 'PHONE_NUMBER',
  country: 'COUNTRY',
  countryMultiselect: 'COUNTRY_MULTISELECT',
  link: 'LINK',
  number: 'NUMBER',
  ratio: 'RATIO',
} as const;

export type TField = {
  id: number;
  creator: TUser;
  section: TSection;
  options: string[];
  program: TProgram;
  user_answer_id: number | null;
  user_answer: string[] | null;
  created_at: string;
  updated_at: string;
  title: string;
  description: string;
  order: number;
  type: ValueOf<typeof FIELD_TYPES>;
  is_required: boolean;
  note: string;
  attachment_type: ValueOf<typeof FIELD_ATTACHMENT_TYPES> | null;
  attachment: TMedia | null;
};
